import React from 'react'
import * as Styled from './styles'

interface Props {
  isExpanded: boolean
  onClick: () => void
  children: React.ReactNode
  testId?: string
}

const ExpandCollapseButton: React.FC<Props> = ({ isExpanded, onClick, children, testId }) => {
  return (
    <Styled.ExpandCollapseButton onClick={onClick} data-testid={testId}>
      <i className={`far fa-${isExpanded ? 'minus' : 'plus'} fa-lg`} aria-hidden="true" />
      {children}
    </Styled.ExpandCollapseButton>
  )
}

export default ExpandCollapseButton
